import React from 'react'
import ReactDOM from 'react-dom'
import './style.css'
import './../node_modules/swiper/swiper-bundle.min.css'
import './../node_modules/animate.css/animate.compat.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.querySelector('#root'),
)
reportWebVitals()
